import React from 'react';
import BarcodeGenerator from '../components/BarcodeGenerator';

const BarcodeGeneratorPage: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-6">
      <div className="bg-white rounded-lg shadow-md p-6">
        <h1 className="text-2xl font-bold text-gray-800 mb-6 pb-2 border-b">Barkod Oluşturucu</h1>
        <BarcodeGenerator />
      </div>
    </div>
  );
};

export default BarcodeGeneratorPage;
